import classNames from 'classnames';
import Image from 'next/image';
import { FormattedMessage } from 'react-intl';
import styles from './StripePayPalButton.module.scss';
import whitePayPalLogoSrc from './white-paypal-logo.svg';

type Props = {
  submitting: boolean;
};

export default function StripePayPalButton({ submitting }: Props) {
  return (
    <button className={classNames(styles.button, styles.darkVariant, styles.roundedCorners)} disabled={submitting} type="submit">
      <span className={styles.text}>
        <FormattedMessage defaultMessage="Continue with" />
        &nbsp;
      </span>
      <span className={styles.logo}>
        <Image alt="" height="18" src={whitePayPalLogoSrc} />
      </span>
    </button>
  );
}
